<template>
	<div class="by-goods-body">
		<ul class="by-goods-content">
			<byGoodsItem v-for="(item,index) in goodsList" :key="index" :itemData="item" @tipShow="tipShow"></byGoodsItem>
		</ul>

		 <el-dialog title="" :visible.sync="dialogVisible" width="750px" height="370px">
      <div class="qrcode">
					<img src="/static/img/logo/code.jpg" alt="">
					<div>
							<div class="mb-15">使用手机微信<span class="normal">“扫一扫”</span></div>
							<div>商城小程序下单,享更多好物</div>
					</div>
			</div>
    </el-dialog>
		
		<el-pagination
				class="page pageNews"	
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="current"
				:page-size="size"
				layout="total, prev, pager, next"
				:total="total">
		</el-pagination>
	</div>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */
import byGoodsItem from '@/components/item/goods_1';
export default {
	components: {
		// 引入组件
		byGoodsItem,
	},
	props: {},
	data() {
		return {
			dialogVisible: false,
			current:1,
			size:8,
			total:0,
			// 产品
			goodsList:[]
		};
	},
	computed: {
		
	},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
		this.getProducts()
	},
	methods: {
		// 展示二维码
    tipShow() {
      this.dialogVisible = true;
    },
		// 获取特色产品
		getProducts(){
			let reqInfo = {};
			reqInfo.current = this.current;
			reqInfo.size = this.size;
			reqInfo.isHot = 1;
			this.$api.Home.getCommodities(reqInfo,res=>{
				this.goodsList = res.data.records
				this.total = res.data.total
			})
		},
		handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.current = val
			this.getAll()
		}
	},
	watch: {
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped>
.qrcode{
	width: 100%;
	height: 220px;
	box-sizing: border-box;
	display: flex;
}

.normal{
	color: #587CE6;
}

.qrcode > div{
	flex: 1;
	padding-left: 50px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 20px;
	color: #333333;
	font-weight: bold;
}

>>> .el-dialog__body{
		padding: 30px 50px 60px 50px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.qrcode > img {
	width: 250px;
	height: 250px;
}
</style>
